import { createApp } from "vue";

import Map from "./Map.vue";
import MapMarkerCategories from "./MapMarkerCategories.vue";

const handle = "almero-vue-map";
const mountEls = document.querySelectorAll(`.${handle}`);

mountEls.forEach((mountEl) => {
    let props = {};
    if (mountEl.dataset.rootProps) {
        try {
            props = JSON.parse(mountEl.dataset.rootProps);
        }
        catch (e) {
            console.error(e);
        }
    }
    const app = createApp(
        Map, {
            ...props,
        }
    );

    app.component("Map", Map);
    app.component("MapMarkerCategories", MapMarkerCategories);

    app.mount(mountEl);
});